import React from 'react';
import { useAppSelector } from '../../hooks/redux';

const ActivityTimeline: React.FC = () => {
  const { transactions } = useAppSelector((state) => state.loyalty);

  if (transactions.length === 0) {
    return (
      <div className="bg-[var(--color-default-background)] p-6 rounded-lg shadow-sm">
        <h3 className="text-lg font-semibold mb-4 text-[var(--color-default-font)]">Recent Activity</h3>
        <p className="text-[var(--color-subtext-color)]">No recent activity</p>
      </div>
    );
  }

  const getActivityIcon = (type: string) => {
    switch (type) {
      case 'project_created':
        return '📝';
      case 'vote_cast':
        return '🗳️';
      case 'comment_added':
        return '💬';
      case 'participation':
        return '🎯';
      default:
        return '✨';
    }
  };

  return (
    <div className="bg-[var(--color-default-background)] p-6 rounded-lg shadow-sm">
      <h3 className="text-lg font-semibold mb-4 text-[var(--color-default-font)]">Recent Activity</h3>
      <div className="space-y-4">
        {transactions.slice(0, 10).map((activity: any, index: number) => (
          <div key={index} className="flex items-start gap-3 pb-4 border-b border-[var(--color-neutral-border)] last:border-0">
            <div className="text-2xl">{getActivityIcon(activity.type)}</div>
            <div className="flex-1">
              <p className="text-sm font-medium text-[var(--color-default-font)]">
                {activity.type?.replace('_', ' ').replace(/\b\w/g, (l: string) => l.toUpperCase())}
              </p>
              {activity.title && <p className="text-sm text-[var(--color-subtext-color)]">{activity.title}</p>}
              <p className="text-xs text-[var(--color-subtext-color)] mt-1">
                {new Date(activity.timestamp).toLocaleString()}
              </p>
            </div>
            {activity.amount && (
              <div className={`text-sm font-semibold ${activity.amount > 0 ? 'text-[var(--color-success-600)]' : 'text-[var(--color-subtext-color)]'}`}>
                {activity.amount > 0 ? '+' : ''}
                {activity.amount}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityTimeline;

